import { Pipe, PipeTransform } from "@angular/core";
import { NewsLinkSource } from "../models/news.model";
import { NewsNavigateService } from "../services/news.navigate.service";

/**
 * Root-relative route to a news item's detail page, for `[routerLink]` on
 * REsource cards: `<a [routerLink]="item | newsRoute: browserLang">`.
 * Pure, so the URL is built once per item instead of on every change detection.
 */
@Pipe({
  name: "newsRoute"
})
export class NewsRoutePipe implements PipeTransform {
  constructor(private newsNavigate: NewsNavigateService) {}

  transform(item: NewsLinkSource, browserLang: string): string | null {
    if (!item) {
      return null;
    }
    return this.newsNavigate.buildNewsRoute(
      item.id,
      item.urlTitle ? item.urlTitle : item.headline,
      browserLang
    );
  }
}
